import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full grid grid-cols-1 lg:grid-cols-2 bg-white" data-testid="landing-page">
      {/* LEFT — visual */}
      <div
        className="relative hidden lg:flex flex-col justify-between border-r-2 border-black overflow-hidden"
        style={{
          backgroundImage:
            'url("https://images.unsplash.com/photo-1777307176207-6ecc9752b715?crop=entropy&cs=srgb&fm=jpg&q=85")',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-white/50" />
        <div className="absolute inset-0 bg-grid-strong opacity-40" />
        <div className="relative z-10 p-10 flex flex-col justify-between h-full">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-black flex items-center justify-center">
              <span className="text-white font-mono text-xs">NT</span>
            </div>
            <span className="font-mono text-xs uppercase tracking-[0.25em]">
              NEW / TRELLO / 2026
            </span>
          </div>

          <div className="space-y-6 max-w-md">
            <div className="inline-block bg-black text-white font-mono text-[10px] uppercase tracking-widest px-2 py-1">
              PAPAN KERJA · BAHASA INDONESIA
            </div>
            <h1 className="font-heading font-black text-6xl xl:text-7xl leading-[0.92] tracking-tighter uppercase">
              Kerja
              <br />
              <span className="text-klein">Terstruktur.</span>
              <br />
              Pikiran
              <br />
              <span className="bg-canary px-2">Tenang.</span>
            </h1>
            <p className="font-mono text-sm max-w-sm text-black/70">
              Kanban brutalis untuk tim yang menolak kompromi visual. Drag, tulis, kelola — tanpa kebisingan UI.
            </p>
          </div>

          <div className="flex justify-between items-end font-mono text-[10px] uppercase tracking-widest">
            <div className="space-y-1">
              <div className="opacity-60">SISTEM</div>
              <div>v1.0 · BRUTALIST EDITION</div>
            </div>
            <div className="space-y-1 text-right">
              <div className="opacity-60">PROYEK</div>
              <div>///// 001</div>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT — CTA */}
      <div className="relative flex items-center justify-center p-6 sm:p-10 bg-white">
        <div className="absolute inset-0 bg-grid opacity-60" />
        <div className="relative w-full max-w-md">
          <div className="space-y-2 mb-10">
            <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-black/60">
              [ 01 / SELAMAT DATANG ]
            </div>
            <h2 className="font-heading font-black text-4xl tracking-tighter uppercase">
              Selamat
              <br />
              Datang.
            </h2>
            <p className="font-mono text-sm text-black/70 pt-2">
              Kelola proyek tim Anda dengan papan Kanban yang cepat, aman, dan sepenuhnya dalam Bahasa Indonesia.
            </p>
          </div>

          <button
            onClick={() => navigate("/login")}
            data-testid="cta-masuk-btn"
            className="group w-full bg-black text-white border-2 border-black px-6 py-4 font-mono uppercase text-sm tracking-wider flex items-center justify-between hover:bg-klein hover:-translate-y-1 hover:shadow-brut transition-all duration-200"
          >
            <span>MASUK KE PAPAN KERJA</span>
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" strokeWidth={2.5} />
          </button>

          <div className="mt-6">
            <button
              onClick={() => navigate("/login?new=1")}
              data-testid="cta-daftar-btn"
              className="group w-full bg-canary text-black border-2 border-black px-6 py-4 font-mono uppercase text-sm tracking-wider flex items-center justify-between hover:bg-black hover:text-white hover:-translate-y-1 hover:shadow-brut transition-all duration-200"
            >
              <span>DAFTAR AKUN BARU</span>
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" strokeWidth={2.5} />
            </button>
          </div>

          <div className="mt-10 pt-6 border-t border-black/20 font-mono text-[10px] uppercase tracking-widest text-black/60 leading-loose">
            <div>OTORISASI · CLOUDFLARE ZERO TRUST</div>
            <div>DATABASE · CLOUDFLARE D1 · EDGE</div>
            <div>AI · WORKERS AI · LLAMA 3.1</div>
          </div>
        </div>
      </div>
    </div>
  );
}
